export enum FollowUpType {
  auto = 1,
  manual = 2,
}
